import { 
    Form,
    useLoaderData,
    redirect,
    useNavigate,
 } from "react-router-dom";
 import Api from "../actions/api"
 import { fetchWithAuth } from "../utils/fetchwithauth";
/*
 export async function action({ request, params }) {
    const formData = await request.formData();
    const updates = Object.fromEntries(formData);
    await updateContact(params.contactId, updates);
    return redirect(`/contacts/${params.contactId}`);
  }
*/
export default function Test() {
  const token = localStorage.getItem("token");   
  const navigate = useNavigate();
  function handleInputChange(e) {
    fetchWithAuth('http://localhost:3001/cliente').then((res) => res.json(),
     console.log('busco datos')
  )
 }

  return (
    <Form method="post" >
      <p>
        <button type="button"
            onClick={(e) => handleInputChange(e)} >Save</button>
        <button type="button"
                onClick={() => {
                navigate(-1);
                }}
        >Cancel</button>
      </p>
    </Form>
  );
}